import React from 'react'
import clsx from 'clsx'

import Link from 'next/link'

import { MenuFooterMainProps } from './FooterMenu.types'
import styles from './FooterMenu.module.scss'

const MenuFooterMain = ({
  items,
  direction,
  className,
  theme,
}: MenuFooterMainProps) =>
  items &&
  !!items.length && (
    <div className={clsx(styles.footerMenuMain, className)}>
      <ul
        className={clsx(
          styles.footerMenuMainUl,
          direction === 'row' && styles.row,
          theme === 'light' && styles.light
        )}
      >
        {items.map(({ label, ...linkProps }, idx) => (
          <li key={idx}>
            <Link {...linkProps}>
              <span dangerouslySetInnerHTML={{ __html: label || '' }} />
            </Link>
          </li>
        ))}
      </ul>
    </div>
  )

export default MenuFooterMain
